import i18next from 'i18next';

const defaultOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
};

export const formatDateValueUTC = (date: number, lng: string) => {
  try {
    return new Intl.DateTimeFormat(lngToLocale(lng), {
      ...defaultOptions,
      timeZone: 'UTC',
    }).format(date);
  } catch (e) {
    return date;
  }
};

export const formatDateValue = (date: number, lng: string) => {
  try {
    return new Intl.DateTimeFormat(lngToLocale(lng), defaultOptions).format(
      date,
    );
  } catch (e) {
    return date;
  }
};

export const formatShortDateValue = (date: number, lng: string) => {
  try {
    return new Intl.DateTimeFormat(lngToLocale(lng), {
      timeZone: 'UTC',
    }).format(date);
  } catch (e) {
    return date;
  }
};

export const formatDateTime = (date: Date) => {
  const options = {
    ...defaultOptions,
    hour: '2-digit',
    minute: '2-digit',
  };
  try {
    return new Intl.DateTimeFormat(
      i18next.languages.map(lngToLocale),
      options,
    ).format(date);
  } catch (e) {
    return date;
  }
};

function lngToLocale(lng: string): string {
  if (lng === 'en') {
    return 'en-GB';
  }

  return lng;
}
